
namespace RioERP.Masters {
    export class TaxRateColumns {
        static columnsKey = 'Masters.TaxRate';
    }
}